import type { HttpPost } from '@/shared/infra/http'
import type { CreateChannel } from '@/modules/connect/use-cases'
import { mapChannelAdminError } from './map-channel-admin-error'
import { type ChannelDto, toChannel } from './channel-dto'

type CreateChannelResponseDto = {
  channel: ChannelDto
}

export class EdgeCreateChannelRepository {
  constructor(private readonly http: HttpPost) {}

  execute: CreateChannel = async (params) => {
    try {
      const data = await this.http.post<unknown, CreateChannelResponseDto>({
        url: '/connect/channels',
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
          name: params.name,
          membershipMode: params.membershipMode,
          memberIds: params.memberIds,
          ...(params.color ? { color: params.color } : {}),
        },
      })
      return { channel: toChannel(data.channel) }
    } catch (err) {
      throw mapChannelAdminError(err)
    }
  }
}
